<template>
    <div v-if="mounted">
        <template v-if="visualizationType === 'pojedynczy'">
            <form-layer-style-polygon-single-symbol v-bind:size="size" @updated="updateValue" @errorMessage="setError" ref="singleSymbol" />
        </template>
        <template v-else-if="visualizationType === 'unikalny'">
            <form-layer-style-polygon-unique-value v-bind:attributes="attributes" v-bind:layer-id="layerId" v-bind:size="size" @updated="updateValue" @errorMessage="setError" ref="uniqueValue" />
        </template>
        <template v-else-if="visualizationType === 'stopniowy'">
            <form-layer-style-polygon-gradual-symbol v-bind:attributes="attributes" v-bind:layer-id="layerId" v-bind:size="size" @updated="updateValue" @errorMessage="setError" ref="gradualSymbol" />
        </template>
    </div>
</template>

<script>
import FormLayerStylePolygonGradualSymbol from "./polygon/FormLayerStylePolygonGradualSymbol.vue";
import FormLayerStylePolygonSingleSymbol from "./polygon/FormLayerStylePolygonSingleSymbol.vue";
import FormLayerStylePolygonUniqueValue from "./polygon/FormLayerStylePolygonUniqueValue.vue";
import LayerStyleStore from "./store/LayerStyleStore";

export default {
  name: "FormLayerStylePolygon",
  props: {
    visualizationType: String,
    value: Object,
    attributes: Array,
    layerId: String,
    size: String
  },
  data() {
    return {
      singleSymbol: null,
      uniqueValue: null,
      gradualSymbol: null,
      mounted: false
    };
  },
  mounted() {
    let store = new LayerStyleStore();
    const initialValue = store.getPolygonStyle();
    if (initialValue != null && initialValue.reguly != null) {
      switch (this.visualizationType) {
        case "pojedynczy":
          store.setPolygonSingleSymbol(initialValue);
          break;
        case "unikalny":
          store.setPolygonUniqueValue(initialValue);
          break;
        case "stopniowy":
          store.setPolygonGradualSymbol(initialValue);
          break;
      }
    }
    this.mounted = true;
  },
  methods: {
    updateValue() {
      let store = new LayerStyleStore();
      let emitValue = null;
      switch (this.visualizationType) {
        case "pojedynczy":
          emitValue = store.getPolygonSingleSymbol();
          break;
        case "unikalny":
          emitValue = store.getPolygonUniqueValue();
          break;
        case "stopniowy":
          emitValue = store.getPolygonGradualSymbol();
          break;
      }
      emitValue = emitValue !== null ? emitValue : {};
      emitValue.reguly = emitValue.reguly != null ? emitValue.reguly : [];
      emitValue.typ = this.visualizationType;
      store.setPolygonStyle(emitValue);
      this.$emit('updated');
    },
    validate() {
      switch (this.visualizationType) {
        case "pojedynczy":
          return this.$refs.singleSymbol.validate();
        case "unikalny":
          return this.$refs.uniqueValue.validate();
        case "stopniowy":
          return this.$refs.gradualSymbol.validate();
      }
    },
    setError(args) {
      this.$emit('errorMessage', args);
    }
  },
  components: {
    FormLayerStylePolygonGradualSymbol,
    FormLayerStylePolygonSingleSymbol,
    FormLayerStylePolygonUniqueValue
  }
};
</script>
<style>
div[size="sm"] {
  width: unset;
}
div[size="sm"] > .custom-file-input {
  width: unset;
}
div[size="sm"] > .custom-file-label {
  height: calc(1.8125rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 0.875rem;
}
div[size="sm"] > .custom-file-label::after {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
  height: 1.8125rem;
}
</style>
<style lang="scss">
  @import "../../style/custom-file.scss";
</style>